import React from 'react';
import './YoutubeEmbed.css';

// Simple, responsive YouTube embed section.
// Pass in just the videoId (the part after "v=" in a YouTube URL).
const YoutubeEmbed = ({ videoId, title }) => (
  <section className="section section--youtube-embed">
    <div className="section__wrapper">
      <div className="youtube-embed__wrapper">
        <iframe
          className="youtube-embed__iframe"
          src={`https://www.youtube.com/embed/${videoId}`}
          title={title || 'Career site video'}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  </section>
);

export default YoutubeEmbed;
